import React from 'react'

export const Account = () => {
  return (
    <div>Account</div>
  )
}
